/**
 * Platform utility functions to handle cross-platform compatibility
 * between Windows, macOS, and Linux
 */

// Detect operating system
export const isWindows =
  typeof window !== "undefined"
    ? navigator.platform.indexOf("Win") > -1
    : typeof process !== "undefined" && process.platform === "win32";

export const isMac =
  typeof window !== "undefined"
    ? navigator.platform.indexOf("Mac") > -1
    : typeof process !== "undefined" && process.platform === "darwin";

export const isLinux =
  typeof window !== "undefined"
    ? navigator.platform.indexOf("Linux") > -1
    : typeof process !== "undefined" && process.platform === "linux";

/**
 * Normalize file paths for the current platform
 * This ensures that file paths work correctly on both Windows and Unix-based systems
 */
export const normalizePath = (path) => {
  if (typeof path !== "string") return path;

  // Convert backslashes to forward slashes on all platforms for consistency
  return path.replace(/\\/g, "/");
};

/**
 * Get a platform-specific keyboard shortcut hint
 */
export const getShortcutKey = (shortcut) => {
  if (isMac) {
    // Replace Ctrl with ⌘ on Mac
    return shortcut.replace("Ctrl", "⌘");
  }
  return shortcut;
};

/**
 * Platform-specific file system path handling
 */
export const joinPaths = (...parts) => {
  // First normalize all parts
  const normalizedParts = parts.map((part) => normalizePath(part));

  // Join with forward slash
  return normalizedParts.join("/").replace(/\/+/g, "/");
};

/**
 * Get the base filename from a path
 */
export const getFilename = (path) => {
  if (!path) return "";
  const normalized = normalizePath(path);
  const parts = normalized.split("/");
  return parts[parts.length - 1];
};

export default {
  isWindows,
  isMac,
  isLinux,
  normalizePath,
  getShortcutKey,
  joinPaths,
  getFilename,
};
